import React, { useState } from 'react';
import axios from '../utils/axiosInstance';
import '../assets/css/adminpanel.css';

const GeneratePDF = () => {
    const [quarter1, setQuarter1] = useState('');
    const [quarter2, setQuarter2] = useState('');
    const [quarter3, setQuarter3] = useState('');
    const [final, setFinal] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleGeneratePDF = async () => {
        if (!quarter1 || !quarter2 || !quarter3 || !final) {
            setError('Please fill in all quarter amounts before generating the PDF.');
            return;
        }
        setLoading(true);
        setError('');
        setSuccessMessage('');

        try {
            const response = await axios.post('/admin/generate-pdf', {
                quarter1,
                quarter2,
                quarter3,
                final,
            }, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'MarylandExpressFundraiserGrid.pdf');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            setSuccessMessage('PDF generated and downloaded successfully!');
        } catch (err) {
            console.error('Error generating PDF:', err);
            setError(err.response?.data?.message || 'Failed to generate PDF. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-panel container">
            <header className="card admin-header">
                <h2>Generate PDF</h2>
                <p>Enter quarter amounts to include in the PDF.</p>
            </header>
            <div className="card">
                <form className="pdf-form" onSubmit={(e) => e.preventDefault()}>
                    <div className="grid columns-4">
                        <div className="form-row">
                            <label htmlFor="quarter1">Q1</label>
                            <input
                                type="number"
                                id="quarter1"
                                value={quarter1}
                                onChange={(e) => setQuarter1(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-row">
                            <label htmlFor="quarter2">Q2</label>
                            <input
                                type="number"
                                id="quarter2"
                                value={quarter2}
                                onChange={(e) => setQuarter2(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-row">
                            <label htmlFor="quarter3">Q3</label>
                            <input
                                type="number"
                                id="quarter3"
                                value={quarter3}
                                onChange={(e) => setQuarter3(e.target.value)}
                                required
                            />
                        </div>
                        <div className="form-row">
                            <label htmlFor="final">Final</label>
                            <input
                                type="number"
                                id="final"
                                value={final}
                                onChange={(e) => setFinal(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <div className="button-container">
                        <button
                            className="button button-primary"
                            onClick={handleGeneratePDF}
                            disabled={loading}
                        >
                            {loading ? 'Generating...' : 'Generate PDF'}
                        </button>
                    </div>
                </form>
                {error && <p className="error-message">{error}</p>}
                {successMessage && <p className="success-message">{successMessage}</p>}
            </div>
        </div>
    );
};

export default GeneratePDF;